import { render, staticRenderFns } from "./RelatorioOfertasTitulo.vue?vue&type=template&id=ba71dcc0"
import script from "./RelatorioOfertasTitulo.vue?vue&type=script&lang=js"
export * from "./RelatorioOfertasTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba71dcc0')) {
      api.createRecord('ba71dcc0', component.options)
    } else {
      api.reload('ba71dcc0', component.options)
    }
    module.hot.accept("./RelatorioOfertasTitulo.vue?vue&type=template&id=ba71dcc0", function () {
      api.rerender('ba71dcc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RelatorioOfertasTitulo.vue"
export default component.exports